// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"4ca631c9","453":"86ac0173"}[chunkId] + ".chunk.js";
};